import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Stack,
} from '@mui/material';
import { copyExportUrl } from '../../common/util/exportExcel';
import { useCatch } from '../../reactHelper';

const ExportFallbackActions = ({ exportUrl, onClear }) => {
  const onCopy = useCatch(async () => {
    await copyExportUrl(exportUrl);
  });

  if (!exportUrl) {
    return null;
  }

  return (
    <Alert severity="info" onClose={onClear}>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        <Button size="small" variant="contained" component="a" href={exportUrl}>
          Abrir arquivo
        </Button>
        <Button size="small" variant="outlined" onClick={onCopy}>
          Copiar link
        </Button>
      </Stack>
    </Alert>
  );
};

ExportFallbackActions.propTypes = {
  exportUrl: PropTypes.string,
  onClear: PropTypes.func,
};

ExportFallbackActions.defaultProps = {
  exportUrl: '',
  onClear: () => {},
};

export default ExportFallbackActions;
